const menu = [

    {
        id: 6,
        category: 'Studio',
        img: 'https://i.ibb.co/9pH6PBF/AP2-BD-1.jpg',
    },
    {
        id: 7,
        category: 'Studio',
        img: 'https://i.ibb.co/x1bh5fX/AP2-BT-1.jpg',
    },
    {
        id: 8,
        category: 'Studio',
        img: 'https://i.ibb.co/jWTMyXv/AP2-LR-1.jpg',
    },
    {
        id: 9,
        category: 'Studio',
        img: 'https://i.ibb.co/Wpw7G9F/AP2-LR-2.jpg',
    },
    {
        id: 10,
        category: 'Studio',
        img: 'https://i.ibb.co/2hDz73g/AP2-LR-3.jpg',
    },
    {
        id: 11,
        category: 'Studio',
        img: 'https://i.ibb.co/k5WW9m8/AP2-LR-4.jpg',
    },


    // stan 2

    {
        id: 12,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/njZvXdX/AP1-BD-1.jpg',
    },
    {
        id: 13,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/jV4KNqH/AP1-BD-2.jpg',
    },
    {
        id: 14,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/Mkjr70F/AP1-BT-1.jpg',
    },
    {
        id: 15,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/bgsVv4t/AP1-BT-2.jpg',
    },
    {
        id: 16,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/5sTt4mD/AP1-LR-1.jpg',
    },
    {
        id: 17,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/W36gL8C/AP1-LR-2.jpg',
    },
    {
        id: 18,
        category: 'Jednosobni apartman',
        img: 'https://i.ibb.co/ByPGmv4/AP1-LR-3.jpg',
    },


    // stan 3

    {
        id: 19,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/pzNxSSL/AP3-BD-1.jpg',
    },
    {
        id: 20,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/5L2tTxT/AP3-BD-2.jpg',
    },
    {
        id: 21,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/crrPB3p/AP3-BD-3.jpg',
    },
    {
        id: 22,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/CvftrRs/AP3-BD-4.jpg',
    },
    {
        id: 23,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/5nwRVmp/AP3-BD-5.jpg',
    },
    {
        id: 24,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/J2kjHPv/AP3-LR-1.jpg',
    },
    {
        id: 25,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/DDjQBqm/AP3-LR-2.jpg',
    },
    {
        id: 26,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/fxZFtKs/AP3-LR-3.jpg',
    },
    {
        id: 27,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/6H2ztwC/AP3-LR-4.jpg',
    },
    {
        id: 28,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/cJtsBZg/AP3-LR-5.jpg',
    },
    {
        id: 29,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/ccWpYgC/AP3-LR-6.jpg',
    },
    {
        id: 30,
        category: 'Dupleks 1',
        img: 'https://i.ibb.co/cXXGsgR/AP3-LR-7.jpg',
    },


    // stan 4

    {
        id: 31,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/cXtqYtX/AP3-BT-1.jpg',
    },
    {
        id: 32,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/PThGxJs/AP4-BD-1.jpg',
    },
    {
        id: 33,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/M7c8ZzS/AP4-BD-2.jpg',
    },
    {
        id: 34,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/w0NNbT9/AP4-BT-1.jpg',
    },

    {
        id: 35,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/XS3pRT1/AP4-LR-1.jpg',
    },
    {
        id: 36,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/YDwB9Df/AP4-LR-2.jpg',
    },
    {
        id: 37,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/D7ZyCmz/AP4-LR-3.jpg',
    },
    {
        id: 38,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/G2vsrNr/AP4-LR-4.jpg',
    },
    {
        id: 39,
        category: 'Dupleks 2',
        img: 'https://i.ibb.co/mTSjGtx/AP4-LR-5.jpg',
    },


];
export default menu;